import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Shop by Category ")
const _hoisted_2 = { class: "justify-content-start parent-item" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back")
const _hoisted_4 = { class: "justify-content-start parent-item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_v_error_text = _resolveComponent("v-error-text")!
  const _component_v_loading = _resolveComponent("v-loading")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (_openBlock(), _createBlock(_component_b_dropdown, {
    ref: "menu",
    xl: "2",
    class: "d-none d-xl-block category-menu",
    "auto-close": "outside"
  }, {
    "button-content": _withCtx(() => [
      _createElementVNode("span", null, [
        _hoisted_1,
        _createVNode(_component_fa, { icon: "chevron-down" })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_error_text, { error: _ctx.error }, null, 8, ["error"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.selectedChildren && !_ctx.selectedGrandchildren)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_b_dropdown_item, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToMainCategories()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_fa, { icon: "chevron-left" }),
                        _hoisted_3
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_dropdown_item, {
                    class: "parent-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToShopPage(_ctx.selectedChildren)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectedChildren.name), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChildren.marketplaceChildren, (child) => {
                    return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                      key: child.id,
                      onClick: _withModifiers(($event: any) => (_ctx.childCategorySelected(child)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(child.name) + " ", 1),
                        (child?.marketplaceChildren?.length > 0)
                          ? (_openBlock(), _createBlock(_component_fa, {
                              key: 0,
                              icon: "chevron-right"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ], 64))
              : (_ctx.selectedChildren && _ctx.selectedGrandchildren)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_b_dropdown_item, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backToChildCategories()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_fa, { icon: "chevron-left" }),
                          _hoisted_5
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_dropdown_item, {
                      class: "parent-item",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToShopPage(_ctx.selectedGrandchildren)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectedGrandchildren.name), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGrandchildren.children, (child) => {
                      return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: child.id,
                        onClick: ($event: any) => (_ctx.navigateToShopPage(child))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ], 64))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                      key: category.id,
                      onClick: _withModifiers(($event: any) => (_ctx.mainCategorySelected(category)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category.name) + " ", 1),
                        (category.marketplaceChildren?.length > 0)
                          ? (_openBlock(), _createBlock(_component_fa, {
                              key: 0,
                              icon: "chevron-right"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
          ], 64))
    ]),
    _: 1
  }, 512))
}